import React from "react";

const ZeuslangStatue = () => {
  // docs
  return <div>documents</div>;
};

export default ZeuslangStatue;
